import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { AUTH_API_URL } from '../config';

const PLAN_LABELS = {
  freemium: 'freemium_title',
  standard: 'standard_title',
  finance: 'finance_title',
  vision: 'premium_title',
  premium: 'premium_title',
};

export default function MobileSubscriptionPage() {
  const { t } = useTranslation('workspace');
  const token = localStorage.getItem('token');
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(false);
    if (!token) {
      setLoading(false);
      setError(true);
      return () => controller.abort();
    }
    fetch(`${AUTH_API_URL}/profile`, {
      headers: { Authorization: `Bearer ${token}` },
      credentials: 'include',
      signal: controller.signal,
    }).then(async (response) => {
      if (!response.ok) throw new Error('Profile unavailable');
      const profile = await response.json();
      setPlan(profile?.plan || null);
    }).catch((loadError) => {
      if (!controller.signal.aborted) setError(true);
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return () => controller.abort();
  }, [token, retry]);

  const planLabel = PLAN_LABELS[plan]
    ? t(`subscription.${PLAN_LABELS[plan]}`, { ns: 'translation' })
    : plan || t('mobileSubscriptionUnavailable');

  return <div className="ws-account-page ws-mobile-subscription-page">
    <Link className="ws-account-back" to="/chat"><FiArrowLeft aria-hidden="true" />{t('accountBack')}</Link>
    <header className="ws-account-heading"><h1>{t('subscription')}</h1></header>
    {loading ? <p role="status">{t('loading')}</p>
      : error ? <div role="alert"><p>{t('loadError')}</p><button type="button" className="ws-secondary" onClick={() => setRetry((value) => value + 1)}>{t('retry')}</button></div>
        : <section className="ws-mobile-subscription-card" aria-label={t('mobileSubscriptionCurrent')}>
          <p>{t('mobileSubscriptionCurrent')}</p>
          <h2>{planLabel}</h2>
        </section>}
  </div>;
}
